import { z } from 'zod';

export const ConfiguracionRowSchema = z.object({
  clave: z.string(),
  valor: z.string(),
  tipo: z.enum(['string', 'number', 'boolean']),
  descripcion: z.string().nullable(),
  updated_at: z.string(),
});
export type ConfiguracionRow = z.infer<typeof ConfiguracionRowSchema>;

export const ConfiguracionUpdateInputSchema = z.object({
  valor: z.string().min(1),
});
export type ConfiguracionUpdateInput = z.infer<typeof ConfiguracionUpdateInputSchema>;
